import React from 'react'

import Container from '@/components/Container/Container'
import styles from './JoinFooter.module.scss'
import { EHeadingType } from '@/components/Heading/Heading'

import VARIABLES from '@/styles/config/_variables.module.scss'
import { useWindowSize } from '@react-hook/window-size'
import dynamic from 'next/dynamic'
const SignUp = dynamic(() => import('@/components/SignUp/SignUp'), { ssr: false })
const Heading = dynamic(() => import('@/components/Heading/Heading'), { ssr: false })

const SectionJoinFooter = ({ className }: { className?: string }) => {
  const [width] = useWindowSize()

  return (
    <section className={`${styles.section} ${className}`}>
      <Container small>
        <div className={styles.inner}>
          <Heading
            type={EHeadingType.footer}
            left
            text="Start work smarter"
            subtext="Get Lazy"
            styleInline={{ marginBottom: width <= parseInt(VARIABLES.mobile) ? '20px' : null }}
          ></Heading>
          <SignUp ctaText="Get started with Lazy now" />
        </div>
      </Container>
    </section>
  )
}

export default SectionJoinFooter
